
import { HTTPClient } from "./Client";

const FuncionalidadeApi = {

    async ObterFuncionalidadeIdAsync(funcionalidadeId) {
        try {
            const response = await HTTPClient.get(`/Funcionalidade/Obter/${funcionalidadeId}?ativo=true`);
            return response.data;
        } catch (error) {
            console.error("Erro ao obter um grupo de usuário:", error)
            throw error;
        }
    },

    async CriarFuncionalidadeAsync(nome, descricao, sistemaId) {
        try {
            const novafuncionalidade = {
                Nome: nome,
                Descricao: descricao,
                SistemaId: sistemaId
            };

            const response = await HTTPClient.post(`/Funcionalidade/CriarFuncionalidade`, novafuncionalidade);

            return response.data;
        } catch (error) {
            console.error("Erro ao criar uma funcionalidade:")
            throw error;
        }

    },

    async AtualizarFuncionalidadeAsync(nome, descricao, sistemaId) {
        try {
            const funcionalidadeAtulizar = {

                Nome: nome,
                Descricao: descricao,
                SistemaId: sistemaId
            };
            const response = await HTTPClient.put(`/Funcionalidade/AtualizarFuncionalidade`, funcionalidadeAtulizar)
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar uma funcionalidade:", error)
            throw error;
        }
    },

    async DeletarFuncionalidadeAsync(funcionalidade) {
        try {

            const response = await HTTPClient.delete(`/Funcionalidade/destivarFuncionalidade/${funcionalidade}`);

            return response.data;
        } catch (error) {
            console.error("Erro ao deletar uma funcionalidade:", error)
            throw error;
        }
    },

    async RestaurarGrupoDeUsuarioAsync(GrupoDeUsuario) {
        try {
            const response = await HTTPClient.put(`/GrupoDeUsuario/Restaurar/${GrupoDeUsuario}`);
            return response.data;
        } catch (error) {
            console.error("Erro ao restaurar um grupo de usuário:", error);
            throw error;
        }

    },

    async ListarFuncionalidadeAsync(ativos) {
        try {
            const response = await HTTPClient.get(`api/Funcionalidade`);
            return response.data;
        } catch (error) {
            console.error("Erro ao listar funcionalidades:", error);
            throw error;
        }
    },


    async BuscarGruposComPaginacaoAsync(nome, pagina, quantidade) {
        try {
            const grupoDeUsuario = {
                Nome: nome,
                Pagina: pagina,
                Quantidade: quantidade,

            };
            const response = await HTTPClient.post(`/GrupoDeUsuario/buscar-paginado`, grupoDeUsuario);
            return response.data;
        } catch (error) {
            console.error("Erro ao listar um grupo de usuário:")
            throw error;
        }

    },

    async ListarFuncionalidadesEnum() {
        try {
            const response = await HTTPClient.get(`/Funcionalidade/ListarEnumFuncionalidades`);
            return response.data;
        } catch (error) {
            console.error("Erro ao listar enum de funcionalidades:", error);
            throw error;
        }
    },

}

export default FuncionalidadeApi;